<template>
  <div class="bout" v-if="score" v-model="score">
    <h1 v-if="score.fencertwo">
      <router-link :to="'/competitor/'+score.fencertwo[0].originalid" v-if="score.fencertwo[0].originalid">
        <span>{{ score.fencertwo[0].lastname }}, {{ score.fencertwo[0].firstname }}</span>
      </router-link>
      <span v-else>{{ score.fencertwo[0].lastname }}, {{ score.fencertwo[0].firstname }}</span>
    </h1>
    <div class="score" v-if="score">
      <p v-if="score.event"><b>Venue: </b>{{score.event.venue}}</p>
      <p v-if="score.event"><b>Event Name: </b><router-link :to="'/event/'+score.event.id">{{score.event.name}}</router-link></p>
      <p><b>Weapon: </b>{{score.weapon}}</p>
      <p v-if="score.age"><b>Age group: </b>{{score.age}}</p>
      <p><b>Date: </b>{{ displayDate }}</p>
      <p><b>Touches scored: </b>{{score.onescore}}</p>
      <p><b>Touches received: </b>{{score.twoscore}}</p>
      <p><b>Type of bout: </b>{{score.type}}</p>
      <p><b>Notes: </b>{{score.notes}}</p>
    </div>
    <div class="actions">
      <router-link :to="'/bout/'+Prev.id" v-if="Prev" :class="'btn btn-primary left'"><i class="icon icon-arrow-left"></i> Previous</router-link>
      <router-link :to="'/bout/'+Next.id" v-if="Next" :class="'btn btn-primary right'">Next <i class="icon icon-arrow-right"></i></router-link>
    </div>
  </div>
</template>

<script>
import config from "@/config"
import dates from "@/utils/dates"

export default {
  name: 'bout',
  beforeRouteEnter (to, from, next) {
    fetch(config.baseUrl+"scores/score/"+to.params.uuid,{
      credentials : "include"
    })
    .then(e => {
      return e.json()
    }).then(j => {
      next(vm => vm.setData(j))
    })
  },
  beforeRouteUpdate (to, from, next) {
    fetch(config.baseUrl+"scores/score/"+to.params.uuid,{
      credentials : "include"
    })
    .then(e => {
      return e.json()
    }).then(j => {
      this.setData(j)
      next(vm => vm.setData(j))
    })
  },
  methods : {
    setData(d){
      this.score = d.score
      this.Next = d.next
      this.Prev = d.prev

      // set up date
      this.displayDate = dates.dayString(new Date(this.score.date))
    },
    getData(){
      return new Promise((resolve, reject) => {
        fetch(config.baseUrl+"scores/score/"+this.$route.params.uuid,{
          credentials : "include"
        })
        .then(e => {
          return e.json()
        }).then(j => {
          this.setData(j)
          resolve()
        })
      })
    }
  },
  created (){
    if(!this.score) this.getData()
  },
  data () {
    return {
      score : undefined,
      Next : undefined,
      Prev : undefined,
      displayDate : ""
    }
  },
}
</script>
<style lang="scss">
  .score {
    p {
      margin: 0;
    }
  }
  .bout {
    margin-right: 20px;
    .actions {
      margin-top: 40px;
      .btn.right {
        float: right;
      }
    }
  }
</style>
